
import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AlertsModule, SystemModule, AccountModule } from "@/store/modules";
import WidgetModule from "@/store/modules/widgets";
import { WidgetResource, WidgetSettingResource, CreateWidgetSettingResource } from "@/models/api/system/widgets";
import Metrics from "@/components/widgets/Metrics.vue";
import MetricWidget from "@/components/widgets/metrics/MetricWidget.vue";
import draggable from "vuedraggable";
import notifications from "@/lib/notifications";

const alertsModule = getModule(AlertsModule);
const systemModule = getModule(SystemModule);
const accountModule = getModule(AccountModule);
const widgetModule = getModule(WidgetModule);

@Component({
  components: {
    Metrics,
    MetricWidget,
    draggable
  }
})
export default class Home extends Vue {
  showTrucks: boolean = false;
  alerts: Array<any> | string = null;
  loading: boolean = false;
  loadingAlerts: boolean = false;
  updating: boolean = false;
  showFacility: boolean = false;
  widgets: Array<WidgetResource> = [];
  widgetSettings: Array<WidgetSettingResource> = [];
  deliveryForIds = null;
  isAddMetricModalVisible: boolean = false;
  selectedMetric: WidgetResource = null;

  created() {
    this.loading = true;
    this.showFacility = systemModule.facilities && systemModule.facilities.length > 1;
    this.loadAlerts();
    this.loadWidgets();
    this.loading = false;
  }

  @Watch("facilityFilter")
  onFacilityChange(val: any) {
    this.loadAlerts();
  }

  @Watch("deliveryForIds")
  onDeliveryForChange(val: any) {
    this.loadAlerts();
  }

  get facilityFilter() {
    if (accountModule.homeFacilitiesUserSettings) {
      return accountModule.homeFacilitiesUserSettings.filter(x=> x && systemModule.facilities.some(y=>y.facilityCode == x));
    }
  }

  set facilityFilter(val) {
    accountModule.updateUserSettings({ settingName: "homeFacilities", values: val });
  }

  loadAlerts() {
    this.loadingAlerts = true;
    var payload = { facilityCodes: null, deliveryForIds: null};

    if (this.facilityFilter) payload.facilityCodes = this.facilityFilter;
    if (this.deliveryForIds) payload.deliveryForIds = this.deliveryForIds;

    alertsModule
      .getOrderAlertCounts(payload)
      .then(response => {
        this.alerts = response.data;
      })
      .finally(() => {
        this.loading = false;
        this.loadingAlerts = false;
      });
  }

  async loadWidgets() {
    this.widgets = await widgetModule.getWidgets();
    this.widgetSettings = await widgetModule.getWidgetSettings();
  }

  alertUrl(alertType) {
    let url = "/dispatch?alert=" + alertType;
    if (this.facilityFilter) url += "&facilityCodes=" + this.facilityFilter.join("&facilityCodes=");
    if (this.deliveryForIds) url += "&deliveryForIds=" + this.deliveryForIds.join("&deliveryForIds=");
    return url;
  }

  async dragDrop(e:any) {
    this.updating = true;
    for (let i = 0; i < this.widgetSettings.length; i++) {
      if (i != this.widgetSettings[i].position) {
        this.widgetSettings[i].position = i;
        await widgetModule.updateWidgetSetting(this.widgetSettings[i]);
      }
    }
    this.updating = false;
    notifications.success('Saved', 'Dashboard order updated.')
  }

  getAddMetricOptionClass(widget: WidgetResource) {
    return `add-metric-option${this.selectedMetric && this.selectedMetric.name == widget.name ? " selected" : ""}`;
  }

  showSelectMetricModal() {
    this.isAddMetricModalVisible = true;
    this.selectedMetric = null;
  }

  selectMetric(widget: WidgetResource) {
    this.selectedMetric = widget;
  }

  async createMetric() {
    this.isAddMetricModalVisible = false;

    var newWidgetSetting: CreateWidgetSettingResource = {
      name: this.selectedMetric.name,
      title: this.selectedMetric.title,
      position: this.widgetSettings.length,
    };
    var widgetSetting = await widgetModule.createWidgetSetting(newWidgetSetting);
    this.widgetSettings.push(widgetSetting);
  }

  widgetRemoved(widgetSettingId: number) {
    this.widgetSettings = this.widgetSettings.filter(x => x.id != widgetSettingId);
  }
}
